import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu"
import { CreationForm } from "../../components/form/CreationForm"
import { CreationFormTemplate } from "../../components/form/CreationForm"
import { DoctorProfileFormTemplate } from "../../data-parsing/myAccount/FormTemplate"
import { useGetMyselfDoctor } from "."
import { Doctor } from "../../data-parsing/doctors/Doctor"
import { Admin } from "../../data-parsing/admins/Admin"



export function MisDatos() {

    const { doctorInfo, isFetching, gotError, updateDoctorInfo, updatePassword } = useGetMyselfDoctor(sessionStorage.getItem("userid"))



    return (<LeftSideMenu active="nutritionist/misDatos">



        <div className="container">

            <div id="wrapper">
                {/* <h1> Hola , esto es /misDatos </h1> */}

                <div className="col-xs-12">
                    <div className="card-box card-tabs m-t-20">
                        <div className="row">
                            <h4 className="header-title m-r-10 m-t-0 pull-right">MIS DATOS</h4>
                        </div>
                        <div className="row">

                            {isFetching ? <h1> Cargando</h1> :
                                <div className="row">

                                    {/* {JSON.stringify(doctorInfo)} */}

                                    {doctorInfo &&
                                        <CreationForm createFunction={(data) => {

                                            console.log("DATA to be sent", JSON.stringify(data))
                                            updateDoctorInfo(
                                                { ...doctorInfo, ...data })
                                        }
                                        }>

                                            <CreationFormTemplate
                                                formTemplate={DoctorProfileFormTemplate}
                                                dataTemplate={Doctor}
                                                defaultData={doctorInfo}
                                                required={false}
                                            />

                                            <div className="col-sm-12">
                                                <button
                                                    className="btn btn-rounded btn-purple m-b-20 ml-10"><i
                                                        className="far fa-save"></i> Actualizar
                                                    Datos
                                                </button>

                                            </div>
                                        </CreationForm>

                                    }
                                </div>}

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </LeftSideMenu>)
}
